import { clearAPIToken, initializeContainer } from '@/libs/di/inversify.config'
import type { Plugin } from 'vuex'
import type { State } from './state'

const API_TOKEN_KEY = 'apiToken' as const

const forgetAPIToken = () => {
  window.localStorage.removeItem(API_TOKEN_KEY)
  clearAPIToken()
}

const getLocalAPIToken = (): APIToken | undefined => {
  const stored = window.localStorage.getItem(API_TOKEN_KEY)
  return stored != null && stored !== ''
    ? (stored as unknown as APIToken)
    : undefined
}

const persistedAPITokenPlugin: Plugin<State> = async store => {
  store.subscribe(async mutation => {
    if (mutation.type === 'clearAPIToken') {
      forgetAPIToken()
      return
    }
    if (mutation.type === 'updateAPIToken') {
      const apiToken = mutation.payload as APIToken
      window.localStorage.setItem(API_TOKEN_KEY, apiToken.toString())
      initializeContainer(apiToken)
    }
  })

  // initialize
  const apiToken = getLocalAPIToken()
  if (apiToken === undefined) {
    initializeContainer()
    window.localStorage.removeItem(API_TOKEN_KEY)
    return
  }
  initializeContainer(apiToken)
  store.replaceState({ ...store.state, apiToken })
}

export const plugins = [persistedAPITokenPlugin]
